import React, { useState } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import classNames from 'classnames';

import Fonts from 'shared/lib/Fonts';

const FamilySettings = (props) => {
  const family = props.family.value;

  const [ displaySelection, setDisplaySelection ] = useState(false);

  const openSelection = () => setDisplaySelection(true);
  const closeSelection = () => setDisplaySelection(false);

  const fonts = Fonts.list();

  const handleSelection = (font) => {
    const { onChange, family: { field } } = props;
    closeSelection();
    onChange(field, font);
  };
  const renderOption = ({ name, font }, index) => {
    return (
      <li style={{fontFamily: font}} key={`font-${index}`}>
        <a onClick={() => handleSelection(font)}>{name}</a>
      </li>
    );
  };
  const wrapperClasses = classNames(
    'btn-group btn-group-wide',
    { 'open': displaySelection },
    { 'dropup': props.direction === 'up' }
  );

  const displayedFontName = family === '' ? i18n.t('default') : family.split(',')[0];

  return (
    <div className="btn-group btn-group-wide">
      <OutsideClickHandler onOutsideClick={closeSelection}>
        <div className={wrapperClasses}>
          <button className="btn btn-form btn-group-wide" onClick={openSelection}>
            {displayedFontName}
          </button>
          <ul className="dropdown-menu">{fonts.map(renderOption)}</ul>
        </div>
      </OutsideClickHandler>
    </div>
  );
};

export default FamilySettings;
